import React from 'react';

const DayAvailableHours = (props) => {

  const onClick = (item) => {
    var data = { year: props.item.year, month: props.item.month, day: props.item.day, startDate: item.startDate, endDate: item.endDate, round: item.round, pickLocation: props.item.pickLocation };
    //console.log('data', data);
    props.onSelectHours(data);
  };

  return (
    <div className='hours-wrapper'>
      {(props.item.hours || []).map((item, index) => (
        <div onClick={() => { onClick(item); }}
          className={`hours ${item.isSelected ? 'active' : ''}`} key={index}>
          בין {item.start}–{item.end}
        </div>
      ))}
    </div>
  );
};
export default DayAvailableHours;

